const layout = {
	"nav-items": {
		dashboard: "Dashboard",
		tasks: "Taken",
		messages: "Berichten",
		hours: "Uren controle",
		"my-hours": "Urenregistratie",
		studentpool: "Connecties",
		talents: "Professionals",
		payments: "Betalingen",
		agreements: "Overeenkomsten",
		"my-profile": "Mijn profiel",
		signout: "Uitloggen",
		"search-tasks": "Opdrachten zoeken",
		"my-tasks": "Mijn opdrachten",
		"my-offers": "Mijn aanbod",
		"my-network": "Mijn netwerk",
		"my-payments": "Mijn betalingen",
		links: "Links",
		faq: "Veelgestelde vragen",
		contact: "Contact",
		"edit-profile": "Profiel aanpassen",
		settings: "Instellingen",
		reviews: "Reviews",
		feedback: "Feedback",
	},
	seo: {
		description:
			"Werk waar je wilt, wanneer je maar wilt & start met verdienen.",
	},
};

export default layout;
